import React, { Component } from 'react';
import Home from '../components/Home'; 
import {jsonUrl,today} from '../components/Factory'

class HomeContainer extends Component {
	componentWillMount(){
		document.body.scrollTop = document.documentElement.scrollTop = 0;
	}	
	render() {
		   let {homeData,kalenderData,newsData,page,staticData} = this.props.resolves;
		   return (
				<Home staticData={staticData} page={page} homeData={homeData } kalenderData={kalenderData} newsData={newsData} />				
            )       
	}
  
}
export function getHomedata(){
	return fetch(jsonUrl({
					number:1,
					type:'pages',
					slug:"home",
					imageembed:true 
				}))
			  .then(res => res.json())
			  .then(res => {
				document.title = res[0].yoast.title
				return res;		 
			  })
}
export function getKalenderData(){
	return fetch(jsonUrl({
						number:16,
						type:'kalender',
						meta_key:"event_start_date",
						orderbymeta:'meta_value',
						meta_type:'date',
						order:"asc",
						meta_query:'&filter[meta_query][0][key]=event_start_date&filter[meta_query][0][value]='+today()+'&filter[meta_query][0][compare]=>=&filter[meta_query][0][type]=date&filter[meta_query][1][key]=event_end_date&filter[meta_query][1][value]='+today()+'&filter[meta_query][1][compare]=>=&filter[meta_query][1][type]=date&filter[meta_query][relation]=OR'
					}))
				  .then(res => res.json())
				  .then(res => { 
					return res.sort((a,b)=>{ return a.kalender_date - b.kalender_date }).slice(0,6);	 
				  })
}
export default HomeContainer;


// WEBPACK FOOTER //
// ./src/containers/Homecontainer.js